import React, { Component } from 'react'
import XMLViewer from "react-xml-viewer";
import { withRouter } from "react-router";
import API from "./apiCalls/accountAPI";
import { Segment, Dimmer } from 'semantic-ui-react';
import { SquareLoader } from "kx-common-components";
import { isValidXml } from './util/index';

const customTheme = {
  attributeKeyColor: "#0074D9",
  attributeValueColor: "#2ECC40",
  cdataColor: "#1D781D",
  commentColor: "#aaa",
  separatorColor: "#333",
  tagColor: "#d43900",
  textColor: "#333",
  overflowBreak: false
};

class XmlRenderer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      match: props.match,
      resLoader: null,
      xmlResponse: null,
      reqLoader: null,
      xmlRequest: null

    }
  }


  componentDidMount(props) {
    const { shipId, status, responseId, countryCode } = this.state.match.params;
    this.setState({ "resLoader": true });
    document.title = `Klearnow | ${shipId} | ${status}`;
    API.getTransactionByResponseId(countryCode, responseId).then((res) => {
      let requestId = res.data.eventMessage.requestId;
      this.setState({ "xmlResponse": res.data.eventMessage.response }, () => {
        this.setState({ "resLoader": false, "reqLoader": true })
        API.getTransactionByRequestId(countryCode, requestId).then((req) => {
          this.setState({ "xmlRequest": req.data.eventMessage.payload }, () => {
            this.setState({ "reqLoader": false })
            let isvalid = isValidXml(req.data.eventMessage.payload)
            if (!isvalid) {
              this.setState({ "invalidXml": true })
            }
          })
        });
      })
    })
  }

  render() {
    return (
      <div className="topDiv">
        <div style={{ "padding": "10px", "width": "100%", "height": "100vh" }}>
          <table style={{ "border": "1px solid #000", "width": "100%" }}>
            <tr style={{ "background": "#fff", "border": "1px solid #000" }}>
              <td style={{ "textAlign": "center" }}><b>RESPONSE</b></td>
              <td style={{ "background": "#dcd9d9", "textAlign": "center" }}><b>REQUEST</b></td>
            </tr>
            <tr>
              <td style={{ "maxWidth": "48vh", "maxHeight": "97vh", "overflow": "scroll", "verticalAlign": "top" }}>
                {
                  this.state.resLoader && !this.state.xmlResponse ? (
                    <Segment className="page-loader-xml">
                      <Dimmer active inverted>
                        <SquareLoader
                          color1={"#1fa2ff"}
                          color2={"#12d8fa"}
                          color3={"#06ffcb"}
                          string={"Preparing Response Xml"}
                        />
                      </Dimmer>
                    </Segment>) :
                    <XMLViewer xml={this.state.xmlResponse} theme={customTheme} />
                }
              </td>
              <td style={{ "background": "#dcd9d9", "maxWidth": "48vh", "maxHeight": "97vh", "overflow": "scroll", "verticalAlign": "top" }}>
                {
                  this.state.reqLoader && !this.state.xmlRequest ? (
                    <Segment className="page-loader-xml">
                      <Dimmer active inverted>
                        <SquareLoader
                          color1={"#1fa2ff"}
                          color2={"#12d8fa"}
                          color3={"#06ffcb"}
                          string={"Preparing Request Xml"}
                        />
                      </Dimmer>
                    </Segment>) :
                    (this.state.invalidXml ? this.state.xmlRequest : <XMLViewer xml={this.state.xmlRequest} theme={customTheme} />)
                }
              </td>
            </tr>
          </table>

        </div>
      </div>
    );
  }
}
export const XmlRendererWithRouter = withRouter(XmlRenderer);
